import api from "../api/axios";

/**
 * Fetch tasks with optional pagination
 * @param {number} page — page number
 * @param {number} pageSize — number of items per page
 */
export const fetchTasksService = (page = 1, pageSize = 10) => {
  return api.get("/tasks", {
    params: { page, pageSize },
  });
};

export const deleteTaskService = (taskId) => api.delete(`/delete-task/${taskId}`);

export const createTaskService = (payload) => api.post("/create-task", payload);

export const updateTaskService = (taskId, payload) => api.put(`/update-task/${taskId}`, payload);
